<template>
  <lf-primary-button-with-dropdown
    :dropdown-items="blockTypes"
    data-cy="add-block-button"
  >
    <template #button>
      {{ $t("BORROWER_PLATFORM.ADD_BLOCK") }}
    </template>
  </lf-primary-button-with-dropdown>
</template>

<script setup lang="ts">
import { markRaw } from "vue";
import { useI18n } from "vue-i18n";

import { BlockType } from "@/enums/bpCustomisation";

import IconButton from "@/components/icons/borrowerPlatform/borrowerTabs/IconButton.vue";
import IconIllustration from "@/components/icons/borrowerPlatform/borrowerTabs/IconIllustration.vue";
import IconImg from "@/components/icons/borrowerPlatform/borrowerTabs/IconImg.vue";
import IconText from "@/components/icons/borrowerPlatform/borrowerTabs/IconText.vue";
import IconTiles from "@/components/icons/borrowerPlatform/borrowerTabs/IconTiles.vue";
import LfPrimaryButtonWithDropdown from "@/components/ui/buttons/LfPrimaryButtonWithDropdown.vue";

import type { IDropdownItem } from "@/models/common";

const { t } = useI18n();

const emit = defineEmits<{
  "add-block": [blockType: BlockType];
}>();

const blockTypes: IDropdownItem[] = [
  {
    label: t("BORROWER_PLATFORM.ADD_BLOCK_MENU.ILLUSTRATION"),
    handler: () => emit("add-block", BlockType.ILLUSTRATION),
    icon: markRaw(IconIllustration),
  },
  {
    label: t("BORROWER_PLATFORM.ADD_BLOCK_MENU.IMAGE"),
    handler: () => emit("add-block", BlockType.IMAGE),
    icon: markRaw(IconImg),
  },
  {
    label: t("BORROWER_PLATFORM.ADD_BLOCK_MENU.TEXT"),
    handler: () => emit("add-block", BlockType.TEXT),
    icon: markRaw(IconText),
  },
  {
    label: t("BORROWER_PLATFORM.ADD_BLOCK_MENU.BUTTON"),
    handler: () => emit("add-block", BlockType.BUTTON),
    icon: markRaw(IconButton),
  },
  {
    label: t("BORROWER_PLATFORM.ADD_BLOCK_MENU.TILES"),
    handler: () => emit("add-block", BlockType.TILES),
    icon: markRaw(IconTiles),
  },
];
</script>
